import InboxRule from 'owa-service/lib/contract/InboxRule';
import NewInboxRuleData from 'owa-service/lib/contract/NewInboxRuleData';
import NewInboxRuleResponse from 'owa-service/lib/contract/NewInboxRuleResponse';
import newInboxRuleOperation from 'owa-service/lib/operation/newInboxRuleOperation';
import newInboxRuleRequest from 'owa-service/lib/factory/newInboxRuleRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Sends out the service request to update an inbox rule
 * @param newInboxRuleData the object that contains the new rule data
 * @return a promise that contains NewInboxRuleResponse
 */
export default function newInboxRuleService(
    newInboxRule: InboxRule
): Promise<NewInboxRuleResponse> {
    let requestBody = newInboxRuleRequest({
        Header: getJsonRequestHeader(),
        InboxRule: newInboxRule as NewInboxRuleData,
    });
    return newInboxRuleOperation(requestBody);
}
